import EcosystemHero from "./components/EcosystemHero";
import EcosystemPartners from "./components/EcosystemPartners";
import EcosystemPillars from "./components/EcosystemPillars";
import EcosystemHowItWorks from "./components/EcosystemHowItWorks";
import EcosystemGovernance from "./components/EcosystemGovernance";

export default function Ecosystem() {
  return (
    <main className="min-h-screen">
      <EcosystemHero />
      <EcosystemPartners />
      <EcosystemPillars />
      <EcosystemHowItWorks />
      <EcosystemGovernance />
    </main>
  );
}